var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-items-view',{attrs:{"content-type":"events","content-type-singular":"event","content-name":"Events","content-name-singular":"Events"}})}
var staticRenderFns = []

export { render, staticRenderFns }